//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";


function createNewAdmin() {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAllAdmins(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/create-new-admin/get-admins?query=${query}`,
                obj
            );
            return handleResponse(res);
        }
        catch (err) {
            handleError(err)
        }
    }
    async function create(values) {
        try {
            const obj = {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            };
    
            const res = await fetch(`${config.host}/cdr-panel/create-new-admin/create`, obj);
            if (!res.ok) {
                const errorData = await res.json();
    
                return {
                    success: false,
                    status: res.status,
                    message: errorData?.message || "Something went wrong",
                };
            }
            return await handleResponse(res);
    
        } catch (err) {
            handleError(err);
        }
    }
    
    
    async function getAllAdminDetail(id) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let res = await fetch(`${config.host}/cdr-panel/create-new-admin/get-new-admin/${id}`, obj);
            return handleResponse(res);
        } 
        catch (err) {
            handleError(err);
        }
    }

    async function update(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values),
            };
            let res = await fetch(`${config.host}/cdr-panel/create-new-admin/update`, obj);
            let body = await res.json();
            return body;
        } 
        catch (err) {}
    }

    async function search(values) {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
                `${config.host}/cdr-panel/create-new-admin/search?query=${encodeURIComponent(query)}`,
                obj
            );
            return handleResponse(res);
        } 
        catch (err) {
            handleError(err);
        }
    }

    async function allAdminExport(values) {
        try {
            const obj = {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"                    
                },
                body: JSON.stringify(values),
            };
            let res = await fetch(`${config.host}/cdr-panel/create-new-admin/export`, obj);
            return handleResponse(res);
        } 
        catch (err) {
            handleError(err);
        }
    }

    return {
        getAllAdmins,
        create,
        getAllAdminDetail,
        update,
        search,
        allAdminExport
    }
}

export default createNewAdmin;